// extracted by mini-css-extract-plugin
export var projectNav = "ProjectNav-module--projectNav--23seU Layout-module--fullWidth--2JSPG";
export var item = "ProjectNav-module--item--3iEjQ";